export default __webpack_public_path__ + "static/media/profile-3.bc197530.png";